import * as PROJECT_CODE from '../../constants/projectCode';
import firebase from '../../lib/firebase.prod';

const firebaseRef = firebase.database();
export default async function getClientEmails(currentUserId, callback) {
	await firebaseRef
		.ref('/kavtek_clients/' + PROJECT_CODE.projectCode + '/salesAgents/')
		.orderByChild('createrID')
		.equalTo(currentUserId)
		.on('value', (snapshot) => {
			var snapshotRef = snapshot.val();

			var salesAgentPointer = Object.keys(snapshotRef)[0];

			var myClients = snapshotRef[salesAgentPointer]['myClients'];

			var myClientsKeys = Object.keys(myClients);

			var clientsEmailArr = [];

			myClientsKeys.forEach((myClientsKey) => {
				var clientEmail = myClients[myClientsKey]['clientEmail'];

				clientsEmailArr.push(clientEmail);
			});

			console.log('clientsEmailArr', clientsEmailArr);

			callback(clientsEmailArr);
		});
}
